import { render, staticRenderFns } from "./EditOnRoad.vue?vue&type=template&id=70e426ec&scoped=true"
import script from "./EditOnRoad.vue?vue&type=script&lang=js"
export * from "./EditOnRoad.vue?vue&type=script&lang=js"
import style0 from "./EditOnRoad.vue?vue&type=style&index=0&id=70e426ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e426ec",
  null
  
)

export default component.exports